import { MitarbeiterSpeicheroptionenContent } from '@/domain/mitarbeiter/features/anlageassistent/components/MitarbeiterSpeicheroptionen/MitarbeiterSpeicheroptionenContent';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import {
  Button,
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from '@e2n/ui/v2';
import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

export function MitarbeiterSpeicheroptionenDrawer() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const [startEmail, _setStartEmail] = useState(
    form.getFieldValue('person.kontakt.email'),
  );
  return (
    <Drawer
      onOpenChange={(open) => {
        if (open === false) {
          form.setFieldValue('person.kontakt.email', startEmail);
        }
      }}>
      <form.Subscribe selector={(state) => [state.isSubmitting]}>
        {([isSubmitting]) => (
          <DrawerTrigger asChild>
            <Button className="w-full" disabled={isSubmitting}>
              {isSubmitting ? (
                <FontAwesomeIcon icon={faSpinnerThird} spin className="mr-2" />
              ) : null}
              {t('domain.mitarbeiter.create.submitButton')}
            </Button>
          </DrawerTrigger>
        )}
      </form.Subscribe>
      <DrawerContent>
        <div className="p-4">
          <DrawerHeader className="space-y-3 pb-6">
            <DrawerTitle>
              {t('domain.mitarbeiter.create.speicheroptionen.dialog.title')}
            </DrawerTitle>
            <DrawerDescription>
              {t(
                'domain.mitarbeiter.create.speicheroptionen.dialog.description',
              )}
            </DrawerDescription>
          </DrawerHeader>
          <MitarbeiterSpeicheroptionenContent />
        </div>
        <DrawerFooter>
          <form.Subscribe selector={(state) => [state.isSubmitting]}>
            {([isSubmitting]) => (
              <Button disabled={isSubmitting} onClick={form.handleSubmit}>
                {isSubmitting ? (
                  <FontAwesomeIcon
                    icon={faSpinnerThird}
                    spin
                    className="mr-2"
                  />
                ) : null}
                {t('actions.fertig')}
              </Button>
            )}
          </form.Subscribe>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
}
